import {
  Box,
  Button,
  Center,
  Container,
  Divider,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Text,
} from "@chakra-ui/react"
import { PageProps } from "gatsby"
import { injectIntl, IntlShape, Link } from "gatsby-plugin-intl"
import { flowResult } from "mobx"
import React, { useRef, useState } from "react"
import { Helmet } from "react-helmet"
import { useForm } from "react-hook-form"
import { useAuthHook } from "../../hooks/useAuthHook"
import logo from "../../images/icon_opaque.png"
import { NavigationContext } from "../../providers/navPage"
import { BottomNavbar } from "../../components/Navbar/BottomNavbar"
import UserStore from "../../store/UserStore"
import { AUTH_MESSAGES, ERROR_MESSAGES } from "../../intl/messages"
import GoogleLogin from "react-google-login"
import GoogleIcon from "../../icons/Google"
import NavbarDefault from "../../components/Navbar"
const Login = ({ data, intl }: { data: any; intl: IntlShape }) => {
  const [loading, setLoading] = useState(false)
  const [gloading, setGLoading] = useState(false)
  const error_text = useRef(null)
  const { register, handleSubmit, errors } = useForm()
  useAuthHook(user => user == true, "/profile/")
  const onSubmit = data => {
    setLoading(true)
    flowResult(UserStore.login(data.email, data.password))
      .then(e => {
        // Successfully Logged In
      })
      .catch(e => {
        error_text.current.innerHTML = intl.formatMessage(
          ERROR_MESSAGES.invalid_creds
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const loginGoogle = googleUser => {
    setGLoading(true)
    flowResult(UserStore.googleLogin(googleUser.getAuthResponse().id_token))
      .then(e => {
        // Successfully Logged In
      })
      .catch(e => {
        error_text.current.innerHTML = intl.formatMessage(
          ERROR_MESSAGES.invalid_creds
        )
      })
      .finally(() => {
        setGLoading(false)
      })
  }
  return (
    <>
      <Helmet title={intl.formatMessage(AUTH_MESSAGES.title)} defer={false}>
        <meta
          name="description"
          content={intl.formatMessage(AUTH_MESSAGES.description)}
        />
      </Helmet>
      <NavigationContext.Provider value={{ page: "login" }}>
        <NavbarDefault
          pos="absolute"
          top="0"
          sx={{ ">div": { maxW: "container.xxxl" } }}
          d={["none", "none", "block"]}
        />
        <BottomNavbar />
      </NavigationContext.Provider>
      <Center pt="50px" as="section" w="100%" minH="calc(100vh - 52px)">
        <Container maxW="container.sm" w="100%">
          <Center mx="auto" mb={7}>
            <Link to="/">
              <Image alt="Briddgy" w="20" src={logo} />
            </Link>
          </Center>
          <Container maxW="container.sm">
            <Heading
              mb={6}
              textAlign="center"
              fontSize="hb2"
              fontWeight="700"
              as="h1"
            >
              {intl.formatMessage(AUTH_MESSAGES.welcome)}
            </Heading>
          </Container>
          <Box
            px={8}
            py={14}
            borderRadius="2rem"
            borderColor="outline.medium"
            borderWidth="1px"
            as="form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormControl w="100%" mb={4}>
              <FormLabel>
                {intl.formatMessage(AUTH_MESSAGES.emailaddress)}
              </FormLabel>
              <Input
                ref={register({
                  required: intl.formatMessage(ERROR_MESSAGES.email_required),
                })}
                size="lg"
                placeholder="someone@email.com"
                type="email"
                name="email"
              />
              <Text color="danger.base" as="small">
                {errors.email?.message}
              </Text>
            </FormControl>
            <FormControl mb={4}>
              <FormLabel>
                {intl.formatMessage(AUTH_MESSAGES.password)}
              </FormLabel>
              <Input
                size="lg"
                ref={register({
                  required: intl.formatMessage(
                    ERROR_MESSAGES.password_required
                  ),
                  minLength: {
                    value: 6,
                    message: intl.formatMessage(
                      ERROR_MESSAGES.password_6_chars
                    ),
                  },
                })}
                placeholder="******"
                type="password"
                name="password"
              />
              <Text color="danger.base" as="small">
                {errors.password?.message}
              </Text>
            </FormControl>
            <Text ref={error_text} color="danger.base" as="small"></Text>
            <br />
            <Link to="/password">
              <Button
                mb={3}
                fontWeight="700"
                color="tealBlue.base"
                variant="link"
              >
                {intl.formatMessage(AUTH_MESSAGES.forgotpassword)}
              </Button>
            </Link>
            <Button
              isLoading={loading}
              fontWeight="600"
              size="lg"
              w="100%"
              type="submit"
              variant="primary_dark"
            >
              {intl.formatMessage(AUTH_MESSAGES.login)}
            </Button>
            <Divider my={5} />
            <GoogleLogin
              clientId="85387336511-t08sv0a4a8r3kkb27b7v388tqo9i8s55.apps.googleusercontent.com"
              onSuccess={loginGoogle}
              cookiePolicy="single_host_origin"
              render={props => (
                <Button
                  d="none"
                  isLoading={gloading}
                  size="lg"
                  gridColumn="span 2"
                  fontWeight="600"
                  leftIcon={<GoogleIcon fontSize="2xl" />}
                  w="100%"
                  onClick={props.onClick}
                  borderRadius="base"
                  variant="outline"
                >
                  {intl.formatMessage(AUTH_MESSAGES.continuegoogle)}
                </Button>
              )}
              onFailure={console.log}
            />
          </Box>
          <Box
            px={3}
            mt={5}
            py={5}
            borderRadius="2rem"
            borderColor="outline.medium"
            borderWidth="1px"
          >
            <Text textAlign="center">
              {intl.formatMessage(AUTH_MESSAGES.newtobriddgy)}{" "}
              <Link to="/signup/">
                <Button fontWeight="700" color="tealBlue.base" variant="link">
                  {intl.formatMessage(AUTH_MESSAGES.createaccount)}
                </Button>
              </Link>
            </Text>
          </Box>
        </Container>
      </Center>
    </>
  )
}

export default injectIntl(Login)
